import React, { useState, useEffect } from "react";
import AgentDetails from "./AgentDetails";
import Header from "./Header";
import PanInput from "./PanInput";
import OTP from "./OTP";
import Timeline from "./Timeline";
import FirstForm from "./FirstForm";
import LastForm from "./LastForm";
import DropDown from "./DropDown";
import { useTranslation } from "react-i18next";

import { onecodeAPI } from "../AppConfig";
import Ineligilble from "./Ineligilble";
import Eligilble from "./Eligible";
import RecommendationFilter from "./RecommendationFilter";

export default function CustomerForm({ isCreditScoreCheck=false }) {
  const [currentScreen, setCurrentScreen] = useState(0);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [profilePicUrl, setProfileUrl] = useState("");
  const [customer, setCustomer] = useState("");
  const [loading, setLoading] = useState(false);
  const [customerName, setCustomerName] = useState("");
  const [customerPhoneNum, setCustomerPhoneNum] = useState("");
  const [onecode, setOnecode] = useState(null);
  const [brandSpecific, setBrandSpecific] = useState(false);
  const [cusStatusforCreditScore, setCusStatusforCreditScore] = useState(0);
  const [cusHashforCreditScore, setCusHashforCreditScore] = useState("");
  const [customerId, setCustomerId] = useState(null);
  const { t, i18n } = useTranslation();

  // useEffect(() => {
  //   // if(onecode != "") {
  //     setTimeout(() => {
  //       createMoengageUser();
  //     }, 1000);
  //   // }
  // }, [onecode])

  useEffect(()=>{
    if(isCreditScoreCheck){
      sessionStorage.setItem("isCreditScoreCheck",true);
    }
    else{
      sessionStorage.removeItem("isCreditScoreCheck");
    }
  },[])

  useEffect(() => {
    if (onecode) {
      window?.Moengage?.track_event("add-customer_customer_page_view");
    }
  }, [onecode]);

  // const createMoengageUser = () => {
  //   window?.Moengage?.add_unique_user_id(onecode);
  // }

  return (
    <div style={{backgroundColor:"white"}}>
      <Header
        currentScreen={currentScreen}
        setCurrentScreen={setCurrentScreen}
        isCreditScoreCheck={isCreditScoreCheck}
      />
      {isCreditScoreCheck ? (
        <div
          style={{
            marginLeft: "15px",
            marginBottom: "50px",
            marginTop: "30px",
          }}
        >
          <h3 style={{ textAlign: "center", fontWeight: "bold",wordSpacing:"2px" }}>
            {t("creditScore.checkCreditScore")}
          </h3>
        </div>
      ) : (
        <AgentDetails
          currentScreen={currentScreen}
          setOnecode={setOnecode}
          setCustomer={setCustomer}
          setLoading={setLoading}
          loading={loading}
          brandSpecific={brandSpecific}
          setBrandSpecific={setBrandSpecific}
        />
      )}

      {currentScreen < 3 && (
        <Timeline
          activeStep={currentScreen}
          isCreditScoreCheck={isCreditScoreCheck}
        />
      )}
      {currentScreen === 0 && !loading && (
        <FirstForm
          setCustomerName={setCustomerName}
          setCustomerPhoneNum={setCustomerPhoneNum}
          setCurrentScreen={setCurrentScreen}
          customer={customer}
          currentScreen={currentScreen}
          isCreditScoreCheck={isCreditScoreCheck}
          setCusStatusforCreditScore={setCusStatusforCreditScore}
          setCusHashforCreditScore={setCusHashforCreditScore}
          setCustomerId = {setCustomerId}
        />
      )}
      {currentScreen === 1 && (
        <OTP
          customerName={customerName}
          customerPhoneNum={customerPhoneNum}
          setCurrentScreen={setCurrentScreen}
          currentScreen={currentScreen}
          isCreditScoreCheck={isCreditScoreCheck}
          cusStatusforCreditScore={cusStatusforCreditScore}
          cusHashforCreditScore={cusHashforCreditScore}
          customerId = {customerId}
          setCustomerId = {setCustomerId}
        />
      )}
      {currentScreen === 2 && (
        <PanInput
          setCurrentScreen={setCurrentScreen}
          currentScreen={currentScreen}
        />
      )}
      {currentScreen === 3 && <LastForm isCreditScoreCheck={isCreditScoreCheck} customerId = {customerId}/>}
      {/* <DropDown /> */}
    </div>
  );
}
